import { useFormContext } from 'react-hook-form';

const EnhancedUseFormContext = () => {
  return useFormContext();
};

export default EnhancedUseFormContext;
